import { IsInt, IsNotEmpty } from 'class-validator';

export class OrderDialogSelectMenuRequestDto {
  @IsNotEmpty()
  @IsInt()
  orderId: number;

  @IsNotEmpty()
  @IsInt()
  menuId: number;
}